import { useMemo } from 'react';

import { usePastClaimsState } from '../usePastClaims';

const now = new Date();
const selectableYearsCount = 6;

type Option<ValueType> = {
  label: string;
  value: ValueType;
};

type UseClaimsOptions<CoverageKey extends string> = {
  previousYearsOptions: Option<string>[];
  getCoverageLabel: (casualty: CoverageKey) => string | undefined;
};

export const useClaimOptions = <CoverageKey extends string>(): UseClaimsOptions<CoverageKey> => {
  const { coverageOptions } = usePastClaimsState();

  const previousYearsOptions = useMemo(
    (): Option<string>[] =>
      [...new Array(selectableYearsCount)].map((_, index) => {
        const year = new Date(now.getFullYear() - index, now.getMonth(), now.getDate()).getFullYear();
        return { label: String(year), value: String(year) };
      }),
    [],
  );

  function getCoverageLabel(coverage: string): string | undefined {
    return coverageOptions?.find((option) => option.value === coverage)?.label;
  }

  return {
    previousYearsOptions,
    getCoverageLabel,
  };
};
